import styled from 'styled-components'
import { ZdsTextButton } from '@zera/components'

const RateButton = styled(ZdsTextButton).attrs(props => ({
  ...props,
  variant: 'secondary-inverse'
}))`
  justify-content: flex-start;
  width: 100%;

  .ZdsTypography {
    color: ${({ theme }) => theme.zds.colors.neutral300};
    white-space: normal;
    overflow: visible;
    height: auto;
    text-align: center;
  }

  &:disabled {
    pointer-events: none;
    .ZdsTypography {
      color: ${({ theme }) => theme.zds.colors.neutral600};
    }
    svg {
      color: ${({ theme }) => theme.zds.colors.neutral600};
    }
  }
`

export const ApproveButton = styled(RateButton)`
  &:hover,
  &.selected {
    background: ${({ theme }) => theme.zds.colors.green600};

    .ZdsTypography {
      color: ${({ theme }) => theme.zds.colors.green300};
    }

    svg {
      color: ${({ theme }) => theme.zds.colors.green300};
    }
  }
`

export const DisapproveButton = styled(RateButton)`
  &:hover,
  &.selected {
    background: ${({ theme }) => theme.zds.colors.red600};

    .ZdsTypography {
      color: ${({ theme }) => theme.zds.colors.red300};
    }

    svg {
      color: ${({ theme }) => theme.zds.colors.red300};
    }
  }

  svg {
    transform: rotate(180deg);
  }
`
